const baseUrl = process.env.NODE_ENV === 'production' ? 'https://dashboard.getclipara.com' : 'http://localhost:3000'
export const serverUrl = process.env.NODE_ENV === 'production' ? 'https://api.getclipara.com' : 'http://localhost:8080'
export default baseUrl
